import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import WorkStudentHelpModal from './WorkStudentHelpModal'
import Modal from 'react-modal'

import FaCaretRight from 'react-icons/fa/arrow-right'
import FaCheck from 'react-icons/fa/check-circle'
import FaPlay from 'react-icons/fa/play-circle'
import FaQuestion from 'react-icons/fa/question-circle'

@autobind
class WorkCommentFormStudent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      comment: '',
      touched: false,
      posting: false,
      step: 1
    }
  }

  handleCommentChange (event) {
    this.setState({comment: event.target.value, touched: true})
  }

  handleKeyDown (e) {
    if (e.key === 'Enter'){
      e.preventDefault()
      if (this.state.comment !== ''){
        if (this.state.step !== 4){
          if (this.state.touched){
            this.nextStep(this.state.step + 1)
          }
        } else {
          this.onCommentSubmit()
        }
      }
    }
  }

  onCommentSubmit (event) {
    event && event.preventDefault()
    this.setState({posting: true})
    API.post(`v3/works/${this.props.id}/comments?include=comment.details,comment.account,comment.account.names,comment.account.avatar,comment.timestamps`, { content: this.state.comment })
    .then(response => {
      this.props.onCommenting(response.data.comment)
      this.setState({
        comment: '',
        posting: false,
        step: 1
      })
    })
  }

  nextStep (step) {
    this.setState({comment: this.state.comment + ' ', touched: false, step: step})
  }

  handleOpenHelpModal (e, step) {
    e.preventDefault()
    this.setState({showHelpModal: true, helpStep: step})
  }

  handleCloseHelpModal () {
    this.setState({showHelpModal: false})
  }

  render () {
    let {user} = this.props
    var avatar = <PobbleAvatar avatar={user.avatar} name={user.display_name} style={{fontSize: '30px'}} className='commentForm__student__avatar' />
    let studentName = this.props.student_type && this.props.student_type.account.display_name ? this.props.student_type.account.display_name + ' ' : ''

    var commentingSuggestions =
      <div className='commentSuggestions__step commentSuggestions__step--1'>
        <header className='commentSuggestions__header'>
          <span className='commentSuggestions__header__step'>1</span>
          <h5 className='commentSuggestions__header__title'>Start your comment with something you like about this piece.</h5>
        </header>
      </div>

    var commentingActions =
      <label htmlFor="commentFormBody" className={`btn btn-primary commentSuggestions__step__btn ${this.state.comment === '' || !this.state.touched ? 'commentSuggestions__step__btn--disabled' : ''}`} disabled={this.state.comment === '' || !this.state.touched} onClick={() => this.nextStep(this.state.step + 1)}>Next step <FaCaretRight /></label>

    if (this.state.step === 2) {
      commentingSuggestions =
        <div className='commentSuggestions__step commentSuggestions__step--2'>
          <header className='commentSuggestions__header'>
            <span className='commentSuggestions__header__step'>2</span>
            <h5 className='commentSuggestions__header__title'>Next, be helpful: make a suggestion.</h5>
          </header>
        </div>
    }

    if (this.state.step === 3) {
      commentingSuggestions =
        <div className='commentSuggestions__step commentSuggestions__step--3'>
          <header className='commentSuggestions__header'>
            <span className='commentSuggestions__header__step'>3</span>
            <h5 className='commentSuggestions__header__title'>Add encouragement for the author.</h5>
          </header>
        </div>
    }

    if (this.state.step === 4) {
      commentingSuggestions =
        <div className='commentSuggestions__step commentSuggestions__step--4'>
          <header className='commentSuggestions__header'>
            <span className='commentSuggestions__header__step'>4</span>
            <h5 className='commentSuggestions__header__title'>Finally, check your spelling and punctuation</h5>
          </header>
        </div>

      commentingActions =
        <button className='btn btn-primary' type='submit' disabled={this.state.comment === '' || this.state.posting}>Post comment <FaCaretRight /></button>

    }

    return (
      <div>
        <form name='commentForm' className='commentForm' onSubmit={this.onCommentSubmit}>
          <header className='commentFormStudent__header'>
            <h4>{`Let's leave a comment`}</h4>
            <button className='btn btn-link' onClick={e => this.handleOpenHelpModal(e, 0)}><FaPlay /> Help</button>
          </header>
          <section className='commentSuggestions'>
            {commentingSuggestions}
          </section>
          <div className='commentForm__box commentForm__box--student commentForm__box--plain'>
            {avatar}
            <textarea id='commentFormBody' value={this.state.comment} onChange={this.handleCommentChange} onKeyDown={this.handleKeyDown} />
            {!user.student_type && <span className='commentForm__tail' />}
          </div>
          <div className='commentForm__actions'>
            {this.state.step !== 4 && <button className='btn btn-link commentFormStudentHelp' onClick={e => this.handleOpenHelpModal(e, this.state.step)}><FaQuestion /> Click here for top tips!</button>}
            {commentingActions}
          </div>
        </form>
        <Modal isOpen={this.state.showHelpModal} contentLabel='Help' onRequestClose={this.handleCloseHelpModal} overlayClassName='modal fade in' style={{content: {background: 'transparent', border: 'none'}}}>
          <WorkStudentHelpModal step={this.state.helpStep} onCloseModal={this.handleCloseHelpModal} />
        </Modal>
      </div>
    )
  }
}

WorkCommentFormStudent.propTypes = {
  id: PropTypes.string,
  onCommenting: PropTypes.func,
  hideCommentCta: PropTypes.func,
  student: PropTypes.object,
  user: PropTypes.object
}

export default WorkCommentFormStudent



// WEBPACK FOOTER //
// ./components/work/WorkCommentFormStudent.js